// extracted by css-extract-rspack-plugin
export default {"paymentSuccessTitleContainer":"paymentSuccessTitleContainer-frVyp1","paymentSuccessIcon":"paymentSuccessIcon-o9nUvh"};